import { useRef, useCallback } from 'react';
import { usePM2DisplayContext } from '@pm2/store';
import { useEntryKey, geogebraEntrySchema, ComponentDisplayContext } from '@utils/component-framework';
import { wrapper } from './comp.root.style.js';
import { Router } from './comp.router.js';
import { jsx } from 'react/jsx-runtime';

function PM2GeogebraComponent(props) {
  const internalRef = useRef(null);
  const rootRef = props.ref ?? internalRef;
  const {
    inLightbox
  } = usePM2DisplayContext();
  const [, onResetEntry] = useEntryKey({
    componentEnvelope: props.component.envelope,
    defaultEntryKey: props.component.entryKey,
    schema: geogebraEntrySchema,
    parentOnResetEntry: props.onResetEntry,
    onEntryKeyReset: useCallback(nextEntryKey => {
      props.node.component.entryKey = nextEntryKey;
    }, [props.node.component])
  });
  return /*#__PURE__*/jsx(ComponentDisplayContext.Provider, {
    value: inLightbox ? "lightbox" : "embedded",
    children: /*#__PURE__*/jsx("article", {
      ref: rootRef,
      className: wrapper,
      children: /*#__PURE__*/jsx(Router, {
        ...props,
        rootRef: rootRef,
        onResetEntry: onResetEntry
      })
    })
  });
}

export { PM2GeogebraComponent };
//# sourceMappingURL=comp.root.js.map
